export default __webpack_public_path__ + "static/media/user.bedb0b2e.svg";